export const convertBytesToGB = (data) => {
  return Math.floor(data / 1073741824)
}

export const convertMinsToHrs = (voice) => {
  return Math.floor(voice / 60)
}
